module.exports = __webpack_public_path__ + "img/icn_confirmation.3aa627cd.svg";